// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPeopleFamily = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M7 10a3 3 0 100-6 3 3 0 000 6m0-2a1 1 0 100-2 1 1 0 000 2m10 2a3 3 0 100-6 3 3 0 000 6m0-2a1 1 0 100-2 1 1 0 000 2"
    />,
    <path d="M8 17.246V20h8v-2.748c-2.195-1.565-5.578-1.767-8-.006M1 14c1.968-1.968 4.568-2.671 7-2.377v2.017c-1.7-.263-3.528.108-5 1.256V18h3v2H1zm15-.373c1.781-.256 3.625.221 5 1.274V18h-3v2h5v-6c-1.77-1.771-4.413-2.67-7-2.391zM12 14a2.5 2.5 0 100-5 2.5 2.5 0 000 5" />
  );
export default SvgIconPeopleFamily;
